import React from 'react';
import ProductCard from '../ProductCard';

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const NewRoofTypeStep = ({ onSelect, selectedRoof }) => {
  const roofTypes = [
    {
      id: 'glass',
      title: 'Glass',
      image: img('conservatory_new_roof_glass', `${BASE_URL}/conservatory-roofs/new-roof-types/glass.jpg`),
    },
    {
      id: 'tiled',
      title: 'Tiled',
      image: img('conservatory_new_roof_tiled', `${BASE_URL}/conservatory-roofs/new-roof-types/tiled.jpg`),
    },
    {
      id: 'hybrid',
      title: 'Hybrid',
      image: img('conservatory_new_roof_hybrid', `${BASE_URL}/conservatory-roofs/new-roof-types/hybrid.jpg`),
    },
    {
      id: 'lantern',
      title: 'Lantern',
      image: img('conservatory_new_roof_lantern', `${BASE_URL}/conservatory-roofs/new-roof-types/lantern-roof.jpg`),
    },
    {
      id: 'flat-skylight',
      title: 'Flat Skylight',
      image: img('conservatory_new_roof_flat_skylight', `${BASE_URL}/conservatory-roofs/new-roof-types/flat-skylight.jpg`),
    },
    {
      id: 'orangery-style',
      title: 'Orangery Style',
      image: img('conservatory_new_roof_orangery_style', `${BASE_URL}/conservatory-roofs/new-roof-types/orangery-style.jpg`),
    },
  ];

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Select Your New Roof Type
      </h2>

      {/* Roof Type Grid */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 sm:grid-cols-2 md:grid-cols-3">
        {roofTypes.map((roof) => (
          <ProductCard
            key={roof.id}
            image={roof.image}
            title={roof.title}
            isSelected={selectedRoof === roof.id}
            onClick={() => onSelect(roof.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default NewRoofTypeStep;
